import PREVIEW from './previewTypes'

export const openPagePreviewer = (pageId) => ({
  type: PREVIEW.OPEN_PAGE_PREVIEWER,
  payload: pageId,
})

export const closePreviewer = () => ({
  type: PREVIEW.CLOSE_PREVIEWER,
})

export const openCanvasPreviewer = () => ({
  type: PREVIEW.OPEN_CANVAS_PREVIEWER,
})



// WEBPACK FOOTER //
// ./src/store/preview/previewActions.js